import { render, staticRenderFns } from "./TotalOrders.vue?vue&type=template&id=1c9a7194&scoped=true&"
import script from "./TotalOrders.vue?vue&type=script&lang=js&"
export * from "./TotalOrders.vue?vue&type=script&lang=js&"
import style0 from "./TotalOrders.vue?vue&type=style&index=0&id=1c9a7194&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9a7194",
  null
  
)

export default component.exports